import axios from '../base/axios';
import API_KEY from './key';

const GET_TVREALITY = 'flixfrenzy/redux/GET_TVREALITY';

// eslint-disable-next-line default-param-last
const tvRealityReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVREALITY:
      return action.payload;
    default:
      return state;
  }
};

export const getTvReality = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10764`).then((res) => {
    dispatch({
      type: GET_TVREALITY,
      payload: res.data,
    });
  });
};

export default tvRealityReducer;
